import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { CustomerService } from 'src/app/generated/backend/services';
import { mapCustomerDto } from 'src/app/utils/customer.utils';
import {
  LoadClientDetailsAction,
  ResetClientDetailsAction,
} from './client-details.actions';
import { ClientDetailsStateModel } from './client-details.state-model';

const defaults: ClientDetailsStateModel = {
  client: null,
};

@State<ClientDetailsStateModel>({
  name: 'clientDetails',
  defaults,
})
@Injectable()
export class ClientDetailsState {
  constructor(private customerService: CustomerService) {}

  @Action(LoadClientDetailsAction)
  loadDetails(
    ctx: StateContext<ClientDetailsStateModel>,
    { customerId }: LoadClientDetailsAction
  ) {
    return this.customerService
      .apiCustomerDetailsCustomerIdGet$Json({
        customerId,
      })
      .pipe(
        tap((response) => {
          ctx.patchState({ client: mapCustomerDto(response) });
        })
      );
  }

  @Action(ResetClientDetailsAction)
  resetDetails(ctx: StateContext<ClientDetailsStateModel>) {
    ctx.setState(defaults);
  }
}
